exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-wrapper .el-submenu .el-submenu__title[data-v-2d2bbdc2]{line-height:.56rem !important}.menu-wrapper .el-menu-item.submenu-title-noDropdown[data-v-2d2bbdc2]{height:.56rem !important;line-height:.56rem !important}", ""]);

// exports
